import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HairSalonIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HairSalonIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.1413 14.9016C12.0022 14.9016 11.8655 14.912 11.7316 14.9311L10.4757 12.1549L12.6665 7.23758C13.3695 5.81526 12.8029 4.07662 11.3626 3.35648C11.2215 3.28591 11.0577 3.27585 10.9089 3.32866C10.7602 3.38147 10.6394 3.49258 10.5744 3.63638L8.59843 8.00506L6.62206 3.6363C6.55699 3.4925 6.43616 3.38142 6.28749 3.32861C6.13881 3.2758 5.97493 3.28586 5.8338 3.35643C4.39248 4.07711 3.82733 5.81621 4.53005 7.23768L6.72311 12.1513L5.47244 14.9165C5.37541 14.9066 5.27703 14.9016 5.17748 14.9016C3.57754 14.9016 2.27588 16.2032 2.27588 17.8032C2.27588 19.4031 3.57754 20.7048 5.17748 20.7048C6.77742 20.7048 8.07908 19.4031 8.07908 17.8032C8.07908 17.7209 8.07479 17.6397 8.06805 17.5592L8.60187 16.361L9.24003 17.7908C9.24003 17.7949 9.23972 17.799 9.23972 17.8032C9.23972 19.4031 10.5414 20.7048 12.1413 20.7048C13.7413 20.7048 15.0429 19.4031 15.0429 17.8032C15.0429 16.2032 13.7413 14.9016 12.1413 14.9016ZM5.58499 6.75366C5.58155 6.74592 5.57791 6.73826 5.57412 6.73064C5.23343 6.04923 5.3854 5.26889 5.85797 4.7632L7.96155 9.41318L7.36282 10.737L5.58499 6.75366ZM5.17749 19.5441C4.21753 19.5441 3.43653 18.7631 3.43653 17.8032C3.43653 16.8432 4.21752 16.0622 5.17749 16.0622C6.13746 16.0622 6.91845 16.8432 6.91845 17.8032C6.91845 18.7631 6.13746 19.5441 5.17749 19.5441ZM7.47621 16.0356C7.23561 15.7234 6.93319 15.4615 6.58716 15.2683L11.3385 4.76325C11.8143 5.2725 11.9608 6.05349 11.6223 6.73065C11.6184 6.73835 11.6147 6.74616 11.6112 6.75402L7.47621 16.0356ZM9.77098 16.1328L9.23678 14.9359L9.84364 13.5737L10.6354 15.3239C10.2947 15.5315 10.0007 15.8078 9.77098 16.1328ZM12.1413 19.5441C11.1813 19.5441 10.4003 18.7631 10.4003 17.8032C10.4003 16.8432 11.1813 16.0622 12.1413 16.0622C13.1013 16.0622 13.8823 16.8432 13.8823 17.8032C13.8823 18.7631 13.1013 19.5441 12.1413 19.5441Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3432 3.29519H16.8612C16.5408 3.29519 16.2809 3.55502 16.2809 3.87551C16.2809 4.196 16.5408 4.45583 16.8612 4.45583H18.6022V5.61647H16.8612C16.5408 5.61647 16.2809 5.8763 16.2809 6.19679C16.2809 6.51728 16.5408 6.77711 16.8612 6.77711H18.6022V7.93775H16.8612C16.5408 7.93775 16.2809 8.19758 16.2809 8.51807C16.2809 8.83856 16.5408 9.09839 16.8612 9.09839H18.6022V10.259H16.8612C16.5408 10.259 16.2809 10.5189 16.2809 10.8394C16.2809 11.1598 16.5408 11.4197 16.8612 11.4197H18.6022V12.5803H16.8612C16.5408 12.5803 16.2809 12.8401 16.2809 13.1606C16.2809 13.4811 16.5408 13.741 16.8612 13.741H18.6022V14.9016H16.8612C16.5408 14.9016 16.2809 15.1614 16.2809 15.4819C16.2809 15.8024 16.5408 16.0622 16.8612 16.0622H18.6022V17.2229H16.8612C16.5408 17.2229 16.2809 17.4827 16.2809 17.8032C16.2809 18.1237 16.5408 18.3835 16.8612 18.3835H18.6022V19.5442H16.8612C16.5408 19.5442 16.2809 19.804 16.2809 20.1245C16.2809 20.445 16.5408 20.7048 16.8612 20.7048H20.3432C21.3031 20.7048 22.0841 19.9238 22.0841 18.9638V5.03615C22.0841 4.07619 21.3031 3.29519 20.3432 3.29519ZM20.9235 18.9638C20.9235 19.2838 20.6632 19.5441 20.3432 19.5441H19.7628V4.45583H20.3432C20.6632 4.45583 20.9235 4.71616 20.9235 5.03615V18.9638Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HairSalonIcon;
